module.exports = __webpack_public_path__ + "static/img/Kyah-Simon.5af4639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Kyah-Simon.jpg
// module id = Ux2u
// module chunks = 0